export { useTranslation } from './hooks/useTranslation';
export type { Translations } from './model/translationModel';
